
import ButtonElement from '@/views/elements/button/ButtonElement';
import WrapperModal from '@/views/elements/WrapperModal';
import { Stack } from '@mui/material';
import Grid from '@mui/material/Grid2';
import classNames from 'classnames/bind';
import { PropertyFilter } from '../Unauthorized/HomeCPComponent';
import styles from './ModalAdvanceFilter.module.scss';
import TypographyElement from '@/views/elements/typography/TypographyElement';
import { useTranslation } from 'react-i18next';


const cx = classNames.bind(styles);

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 'auto',
    bgcolor: 'background.paper',
    boxShadow: 24,
    px: 2,
    pt: 2,
    pb: 4,
    borderRadius: 2
};

export default function ModalAdvanceFilter({
    open,
    handleClose,
    handleSave,
    handleReset,
    handleChange,
    previewData
}: {
    open: boolean;
    handleClose: () => void;
    handleSave: () => void;
    handleReset: () => void;
    handleChange: (id: keyof PropertyFilter, value: string | number) => void;
    previewData: PropertyFilter;
}) {
    const { t } = useTranslation()

    const handleSaveAndClose = () => {
        handleSave();
        handleClose();
    }

    const handleCloseAndReset = () => {
        handleReset();
        handleClose();
    }

    return (
        <WrapperModal
            open={open}
            handleClose={handleCloseAndReset}
            title={t('copytrade.advanceFilter.title')}
        >
            <Stack className={cx('adv-filter')} direction={'column'} spacing={2}>

                <Stack spacing={2} direction={'column'}>
                    <TypographyElement>
                        {t('copytrade.advanceFilter.timeRange')}
                    </TypographyElement>
                    <Grid container spacing={1} columns={12}>
                        <Grid size={3}>
                            <ButtonElement
                                onClick={() => handleChange('time', 1)}
                                customType='Transparent'
                                className={Number.parseInt(previewData.time.toString()) === 1 ? "size-small actived" : "size-small"}>
                                1 {t('copytrade.common.month')}
                            </ButtonElement>
                        </Grid>

                        {/* <Grid size={3}>
                            <ButtonElement customType='Transparent' className="size-small">
                                1 tháng
                            </ButtonElement>
                        </Grid> */}
                    </Grid>

                </Stack>

                <Stack spacing={2} direction={'column'}>
                    <TypographyElement>
                        {t('copytrade.advanceFilter.efficientByInvest')}
                    </TypographyElement>
                    <Grid container spacing={1} columns={12}>
                        <Grid size={3}>
                            <ButtonElement customType='Transparent' className="size-small">
                                &gt; 0
                            </ButtonElement>
                        </Grid>

                        <Grid size={3}>
                            <ButtonElement customType='Transparent' className="size-small">
                                &gt; 25
                            </ButtonElement>
                        </Grid>

                        <Grid size={3}>
                            <ButtonElement customType='Transparent' className="size-small">
                                &gt; 50
                            </ButtonElement>
                        </Grid>

                        <Grid size={3}>
                            <ButtonElement customType='Transparent' className="size-small">
                                &gt; 100
                            </ButtonElement>
                        </Grid>

                        <Grid size={3}>
                            <ButtonElement customType='Transparent' className="size-small">
                                &lt; 0
                            </ButtonElement>
                        </Grid>

                        <Grid size={3}>
                            <ButtonElement customType='Transparent' className="size-small">
                                &lt; 25
                            </ButtonElement>
                        </Grid>

                        <Grid size={3}>
                            <ButtonElement customType='Transparent' className="size-small">
                                &lt; 50
                            </ButtonElement>
                        </Grid>

                        <Grid size={3}>
                            <ButtonElement customType='Transparent' className="size-small">
                                &lt; 100
                            </ButtonElement>
                        </Grid>

                    </Grid>

                </Stack>

                <Stack spacing={2} direction={'column'}>
                    <TypographyElement>
                        {t('copytrade.advanceFilter.totalCopyAsset')}
                    </TypographyElement>
                    <Grid container spacing={1} columns={12}>
                        <Grid size={3}>
                            <ButtonElement customType='Transparent' className="size-small">
                                &gt; 20 {t('copytrade.common.million')}
                            </ButtonElement>
                        </Grid>

                        <Grid size={3}>
                            <ButtonElement customType='Transparent' className="size-small">
                                &gt; 100 {t('copytrade.common.million')}
                            </ButtonElement>
                        </Grid>

                        <Grid size={3}>
                            <ButtonElement customType='Transparent' className="size-small">
                                &gt; 250 {t('copytrade.common.million')}
                            </ButtonElement>
                        </Grid>

                        <Grid size={3}>
                            <ButtonElement customType='Transparent' className="size-small">
                                &gt; 500 {t('copytrade.common.million')}
                            </ButtonElement>
                        </Grid>

                    </Grid>

                </Stack>

                <Stack spacing={2} direction={'column'}>
                    <TypographyElement>
                        {t('copytrade.advanceFilter.minCopy')}
                    </TypographyElement>
                    <Grid container spacing={1} columns={12}>
                        <Grid size={3}>
                            <ButtonElement onClick={() => handleChange('minInvest', 20)}
                                customType='Transparent'
                                className={Number.parseInt(previewData.minInvest.toString()) === 20 ? "size-small actived" : "size-small"}>
                                &lt; 20 {t('copytrade.common.million')}
                            </ButtonElement>
                        </Grid>

                        <Grid size={3}>
                            <ButtonElement onClick={() => handleChange('minInvest', 100)}
                                customType='Transparent'
                                className={Number.parseInt(previewData.minInvest.toString()) === 100 ? "size-small actived" : "size-small"}>
                                &lt; 100 {t('copytrade.common.million')}
                            </ButtonElement>
                        </Grid>

                        <Grid size={3}>
                            <ButtonElement
                                onClick={() => handleChange('minInvest', 250)}
                                customType='Transparent'
                                className={Number.parseInt(previewData.minInvest.toString()) === 250 ? "size-small actived" : "size-small"}>
                                &lt; 250 {t('copytrade.common.million')}
                            </ButtonElement>
                        </Grid>

                        <Grid size={3}>
                            <ButtonElement
                                onClick={() => handleChange('minInvest', 500)}
                                customType='Transparent'
                                className={Number.parseInt(previewData.minInvest.toString()) === 500 ? "size-small actived" : "size-small"}>
                                &lt; 500 {t('copytrade.common.million')}
                            </ButtonElement>
                        </Grid>

                    </Grid>

                </Stack>

                <Stack
                    direction={"row"}
                    spacing={2}
                    justifyContent={"center"}
                >
                    <ButtonElement
                        customType="Secondary"
                        onClick={handleReset}
                        className={cx("btn-register")}
                        variant="contained">{t('copytrade.common.cancel')}</ButtonElement>

                    <ButtonElement
                        customType="Primary"
                        onClick={handleSaveAndClose}
                        className={cx("btn-register")}
                        variant="contained">{t('copytrade.common.confirm')}</ButtonElement>
                </Stack>

            </Stack>
        </WrapperModal >
    );
}
